import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const News = () => {
  const [newsList, setNewsList] = useState([]);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await fetch("/api/public/news");
        const result = await res.json();

        if (Array.isArray(result.data)) {
          setNewsList(result.data);
        } else {
          console.error("データ形式が不正です:", result);
        }
      } catch (err) {
        console.error("お知らせ取得に失敗:", err);
      }
    };

    fetchNews();
  }, []);

  return (
    <div className="max-w-3xl mx-auto py-12 px-4">
      <h1 className="text-2xl font-bold mb-6 text-center">お知らせ</h1>

      <ul>
        {newsList.map((item) => (
          <li key={item.id} className="mb-6 border-b pb-4">
            <p className="text-sm text-gray-500">
              {new Date(item.createdAt || item.updatedAt).toLocaleDateString("ja-JP", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </p>
            <Link
              to={`/news/${item.id}`}
              className="text-blue-600 hover:underline font-medium block mt-1"
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>

      {newsList.length === 0 && (
        <p className="text-center text-gray-500 mt-8">読み込み中...</p>
      )}
    </div>
  );
};

export default News;
